import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import UsersSearchSource from 'flarum/forum/components/UsersSearchSource';

// 组件
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';

// 工具
import highlight from 'flarum/common/helpers/highlight';
import username from 'flarum/common/helpers/username';

/** 重写 搜索  过滤黑名单用户  */
export default function () {
  override(UsersSearchSource.prototype, 'view', function (_vi, query) {
    query = query.toLowerCase();
    const results = (this.results.get(query) || []).concat(app.store.all('users').filter(user => !user.ignore_all()).filter(user => [user.username(), user.displayName()].some(value => value.toLowerCase().substr(0, query.length) === query))).filter((e, i, arr) => arr.lastIndexOf(e) === i).sort((a, b) => a.displayName().localeCompare(b.displayName()));
    if (!results.length) return [];
    return [m("li", {
      className: "Dropdown-header"
    }, app.translator.trans('core.forum.search.users_heading')), ...results.map(user => {
      const name = username(user);
      const children = [highlight(name.text, query)];
      return m("li", {
        className: "UserSearchResult",
        "data-index": 'users' + user.id()
      }, m(Link, {
        href: app.route.user(user)
      }, m(Avatar, {
        user: user
      }), _objectSpread(_objectSpread({}, name), {}, {
        text: undefined,
        children
      })));
    })];
  });
}